var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.843,
    height: 7,
    viewBox: "0 0 19.843 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M1.846,44.519-1.193,41.48a.457.457,0,0,0-.326-.134.457.457,0,0,0-.326.134l-.276.276a.457.457,0,0,0-.134.326.466.466,0,0,0,.134.329l1.773,1.777H-17.408a.449.449,0,0,0-.455.453v.39a.467.467,0,0,0,.455.473H-.327L-2.12,47.29a.45.45,0,0,0-.134.323.454.454,0,0,0,.134.324l.276.275a.457.457,0,0,0,.326.134.457.457,0,0,0,.326-.135l3.039-3.039a.464.464,0,0,0,0-.654Z",
    transform: "translate(17.863 -41.346)",
    fill: "#ee2c3c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerArrow);
export default __webpack_public_path__ + "static/media/hamburger-arrow.3d7995497def6440fedd4620ed58f2f7.svg";
export { ForwardRef as ReactComponent };